import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Row, Col } from "antd";
import QuestionItemShare from "../../components/forms/QuestionItemShare";
import FormTitleInput from "../../components/forms/shared/FormTitleInput";
import DescriptionInput from "../../components/forms/shared/DescriptionInput";
import { getFormById } from "../../redux/actions/GetFormFromIdActions";
import { createResponse } from "../../redux/actions/CreateResponseActions";
import "./Share.css";

const Share = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const listForm = useSelector((state) => state.getFormById);
  const formulaire = listForm?.form?.form || [];

  // console.log(listForm);

  useEffect(() => {
    dispatch(getFormById(id));
  }, [id, dispatch]);

  const [reponses, setReponses] = useState({});

  const handleChange = (label, value) => {
    setReponses((prev) => ({ ...prev, [label]: value }));
  };

  // rejet le formulaire
  const handleReset = () => {
    setReponses({});
    setErreurs({});
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [erreurs, setErreurs] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErreurs = {};
    let hasErrors = false;

    const convertValueToString = (value) => {
      if (value === null || value === undefined) return "";

      if (value instanceof Date) {
        return value.toISOString();
      }

      if (typeof value === "object") {
        // pour tableau, object, etc.
        return JSON.stringify(value);
      }

      return String(value);
    };

    formulaire.fields.forEach((field) => {
      const label = field.label;
      const rawValue = reponses[label];

      const isEmpty =
        rawValue === null ||
        rawValue === undefined ||
        (typeof rawValue === "string" && rawValue.trim() === "") ||
        (Array.isArray(rawValue) && rawValue.length === 0);

      if (field.required && isEmpty) {
        newErreurs[label] = "Champ requis";
        hasErrors = true;
      }
    });

    setErreurs(newErreurs);
    if (hasErrors) return;

    const formData = new FormData();
    const answers = [];

    formulaire.fields.forEach((field) => {
      const label = field.label;
      const value = reponses[label];

      if (field.type === "file" && Array.isArray(value) && value.length > 0) {
        // On prend le premier fichier (ou tous si multi-upload)
        value.forEach((fileObj, idx) => {
          if (fileObj.originFileObj instanceof File) {
            const fileKey = `file_${field.id}`;
            formData.append(fileKey, fileObj.originFileObj);
            answers.push({
              fieldId: field.id,
              value: fileKey,
            });
          }
        });
      } else {
        answers.push({
          fieldId: field.id,
          value: convertValueToString(value) || "",
        });
      }
    });

    formData.append("answers", JSON.stringify(answers));

    const rep = await dispatch(createResponse(id, formData));
    if (rep) {
      // Réponse soumise avec succès - pas besoin de récupérer les données admin
      setShowSuccess(true);
    }
  };

  return (
    <div className="share-container">
      {!showSuccess ? (
        <Row justify="center" style={{ paddingTop: "20px" }}>
          <Col
            xs={24}
            sm={22}
            md={18}
            lg={12}
            xl={12}
            className="share-form-container"
          >
            <Card
              className="share-form-card cardTitleDescriptionInput"
              style={{ borderTop: "10px solid #43CE0C" }}
            >
              <div>
                <FormTitleInput
                  name="title"
                  value={formulaire.title}
                  className="titrFormulaire"
                  variant="borderless"
                />
                <DescriptionInput
                  name="description"
                  value={formulaire.description}
                />
              </div>
            </Card>
            <form onSubmit={handleSubmit}>
              {formulaire?.fields?.map((q, index) => (
                <Card
                  key={`${q.id}-${index}`}
                  className="share-question-card"
                  style={{ textAlign: "left" }}
                >
                  <div className="share-question-label">
                    {q.label || `Question ${index + 1}`}
                    {q.required && <span style={{ color: "red" }}> *</span>}
                  </div>

                  <QuestionItemShare
                    question={q}
                    isCollapsed={true}
                    disabled_={false}
                    value={reponses[q.label] || ""}
                    onChange={(val) => handleChange(q.label, val)}
                  />

                  {/* Message d'erreur affiché dynamiquement */}
                  {erreurs[q.label] && (
                    <div className="share-error-message">
                      {erreurs[q.label]}
                    </div>
                  )}
                </Card>
              ))}

              <Row gutter={[16, 16]} style={{ marginBottom: "50px" }}>
                <Col xs={24} sm={12}>
                  <Button htmlType="submit" className="share-submit-btn">
                    Envoyer
                  </Button>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span onClick={handleReset} className="share-reset-text">
                    Effacer le formulaire
                  </span>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      ) : (
        <div style={{ minHeight: "100vh" }}>
          <Row justify="center" style={{ paddingTop: "50px" }}>
            <Col xs={24} sm={22} md={18} lg={12} xl={12}>
              <Card
                className="share-form-card cardTitleDescriptionInput"
                style={{ borderTop: "10px solid #43CE0C" }}
              >
                <div>
                  <FormTitleInput
                    name="title"
                    value="REPONSE AUX QUESTIONS"
                    className="titrFormulaire"
                    variant="borderless"
                  />
                  <DescriptionInput
                    name="description"
                    value="Votre réponse a bien été enregistrée."
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default Share;
